import { ProtoBaseModel, attr, repeated } from '@square/dashboard-data/utils/ember-model-stubs';
import { TenderSettings as TenderSettingsProto } from '@square/dashboard-protos/models/squareup/devicesettings/profiles/v2/model/settings/common/payment_types';
import Enum from '@square/dashboard-utilities/utils/enum';
export const TenderType = new Enum(Object.keys(TenderSettingsProto.TenderType));
export const TenderSettings = ProtoBaseModel.extend({
  primaryTender: repeated(TenderType),
  secondaryTender: repeated(TenderType),
  disabledTender: repeated(TenderType),
  hasPrimaryTender: attr(Boolean),
  hasSecondaryTender: attr(Boolean),
  hasDisabledTender: attr(Boolean)
});
export default ProtoBaseModel.extend({
  skipPaymentTypeSelection: attr(Boolean),
  skipItemizedCart: attr(Boolean),
  skipReviewSale: attr(Boolean),
  tenderSettings: attr(TenderSettings)
});